import { MOKA_MATCH_ANALYSIS_MINIMUM_DISPLAY_PERCENT, MOKA_MATCH_ANALYSIS_PERCENTAGE_DECIMAL_COUNT, MOKA_MATCH_PERCENT_MULTIPLIER } from "@/constants";
const formatMokaMoveWinProbability = blackWinProbability => {
  const blackWinPercentage = blackWinProbability * MOKA_MATCH_PERCENT_MULTIPLIER;
  if (blackWinPercentage > 0 && blackWinPercentage < MOKA_MATCH_ANALYSIS_MINIMUM_DISPLAY_PERCENT) {
    return `<${MOKA_MATCH_ANALYSIS_MINIMUM_DISPLAY_PERCENT.toFixed(MOKA_MATCH_ANALYSIS_PERCENTAGE_DECIMAL_COUNT)}%`;
  }
  return `${blackWinPercentage.toFixed(MOKA_MATCH_ANALYSIS_PERCENTAGE_DECIMAL_COUNT)}%`;
};
export { formatMokaMoveWinProbability };